import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../containers/LoginMiCuenta'

const Login = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

Login.propTypes = {
    children: PropTypes.node
}

export default Login